export default {
  blends: {
    validationMessage:{
      requiredMessage:'Questo campo è obbligatorio',
      isNumber:'Deve essere un numero',
      isValidNumber:'Deve essere un numero valido',
      noNegativeNumbers:'Non sono ammessi numeri negativi',
      atLeastTwoProducts:'Sono richiesti almeno due prodotti',
    },
    exemptProducts: {
      eudrExemptProducts: 'Prodotti Esenti da EUDR',
      addEUDRExemptProduct: 'Aggiungi Prodotto Esente da EUDR',
      updateEUDRExemptProduct: 'Aggiorna Prodotto Esente da EUDR',
      internalRefNumber: 'Numero di Riferimento Interno',
      supplier: 'Fornitore',
      containerID: 'ID Contenitore',
      product: 'Prodotto',
      quantity: 'Quantità',
      dateAdded: 'Data Aggiunta',
      addProduct: 'Aggiungi Prodotto',
      selectDate: 'Seleziona Data',
      addContainer: 'Aggiungi Contenitore',
      containerInformation: 'Informazioni Contenitore',
      supplierInformation: 'Informazioni sul Fornitore',
      supplierInformationTT: 'Dettagli sull’entità che fornisce beni o servizi.',
      supplierTooltip:
        'Seleziona il fornitore dall’elenco pre-registrato nel sistema.',
      addnewSupplier: 'Aggiungi Nuovo Fornitore',
      internalReferenceNumberMustBeAlphanumeric:
        'Il numero di riferimento interno deve essere alfanumerico',
      netMassMustBeValid: 'La massa netta deve essere valida',
      volumeMustBeNumeric: 'Il volume deve essere numerico',
      subProduct: 'Sottoprodotto',
      netMass: 'Massa Netta',
      volume: 'Volume',
      productDetail: 'Dettagli del Prodotto',
      placeOfActivity: 'Luogo dell’Attività',
      countryOfActivity: 'Paese dell’Attività',
      countryOfEntry: 'Paese di Entrata',
      activity: 'Attività',
      internalRefNo: 'Numero di Riferimento Interno',
      name: 'Nome',
      email: 'Email',
      phoneNumber: 'Numero di Telefono',
      country: 'Paese',
      status: 'Stato',
      addNewSupplier: 'Aggiungi Nuovo Fornitore',
      availableForBlends: 'Disponibile per Miscele',
      thisFieldIsRequired: 'Questo campo è obbligatorio.',
      enterSupplierFirstName: 'Inserisci il Nome del Fornitore',
      enterSupplierLastName: 'Inserisci il Cognome del Fornitore',
      enterEmailAddress: 'Inserisci l’Indirizzo Email',
      enterPhoneNumber: 'Inserisci il Numero di Telefono',
      selectCountry: 'Seleziona Paese',
      firstNameIsRequired: 'Il nome è obbligatorio',
      lastNameIsRequired: 'Il cognome è obbligatorio',
      unAvailableForBlends: 'Non Disponibile per Miscele',
      exemptAddedSuccessfully: 'Prodotto esente da EUDR aggiunto con successo!',
      unExpectedErrorMsg: 'Si è verificato un errore imprevisto. Riprova.',
      availabilityStatusMsg:
        'Lo stato di disponibilità per le miscele è stato aggiornato con successo.',
      updateProduct: 'Aggiorna Prodotto',
      exemptUpdatedSuccessfully:
        'Prodotto esente da EUDR aggiornato con successo!',
      invalidNumericValue: 'Valore numerico non valido',
      containerIDTT:
        'Questo è un identificatore univoco del Contenitore. Inserisci l’ID del Contenitore di seguito.',
        actions:'Azioni',
    },
  
    blends: 'Miscele',
    blendSetting: 'Impostazioni Miscela',
    createBlendDds: 'Crea Miscela Dds',
    country: 'Paese',
    countryTT: 'Paese',
    select: 'Seleziona',
    edurDueDeligenceStatus: 'Stato Due Diligence EUDR',
    dueDiligenceStatus: 'Stato Due Diligence',
    EUDRDeforestationStatusTT: 'Stato Deforestazione EUDR',
    dueDeligenceStatus: 'Stato Due Diligence',
    uploadedToEU: 'Caricato in EU',
    pending: 'In attesa',
    underReview: 'In revisione',
    compliant: 'Conforme',
    nonCompliant: 'Non Conforme',
    processingFarm: 'Elaborazione Fattoria',
    analyzingDeforestation: 'Analisi Deforestazione',
    writingToBlockchain: 'Scrittura su Blockchain',
    readyToProceed: 'Pronto per Procedere',
    mitigationRequired: 'Mitigazione Necessaria',
    viewReport: 'Visualizza Rapporto',
    share: 'Condividi',
    copyAndCreateNew: 'Copia e Crea Nuovo',
    remove: 'Rimuovi',
    eudrRefNo: 'Rif. EUDR/Interno',
    finalProduct: 'Titolo Miscela & ID Lotto Miscela',
    noOfIngredients: 'Numero di Ingredienti',
    farmsAndQuantity: 'Fattorie & Quantità',
    actions: 'Azioni',
    confirmDialog: {
      delete: {
        title: 'Elimina Miscela',
        message: 'Sei sicuro di voler eliminare questa Miscela?',
        confirmBtn: 'Conferma',
        cancelBtn: 'Annulla',
      },
    },
    searchBlend: 'Cerca Miscela per Prodotto Finale',
    blendDuplicatedSuccessfully: 'Miscela duplicata con successo.',
    reportDeletedSuccessfully: 'Rapporto eliminato con successo.',
    
    blendSettings: {
      dashboard: 'Pannello di Controllo',
      blendSettings: 'Impostazioni Miscele',
      importBlends: 'Importa Miscele',
      addNewBlend: 'Aggiungi Nuova Miscela',
      searchTitle: 'Cerca per Titolo della Miscela',
      view: 'Visualizza',
      edit: 'Modifica',
      remove: 'Rimuovi',
      farms: 'Fattorie',
      blendCode: 'Codice Miscela',
      blendTitle: 'Titolo Miscela',
      description: 'Descrizione',
      'finalProductName&Code': 'Nome e Codice del Prodotto Finale',
      dateAdded: 'Data Aggiunta',
      actions: 'Azioni',
      addBlend: 'Aggiungi Impostazioni Miscela',
      cancel: 'Annulla',
      createBlend: 'Crea Miscela',
      generalData: 'Dati Generali',
      generalDataTT: "Questa etichetta mostra tutti i dati sullo schermo.",
      blendTitleTT: "Il menu a discesa può essere aperto facendo clic su di esso, rivelando un elenco di miscele disponibili per la selezione.",
      enterHere: 'Inserisci qui',
      blendCodeTT: 'Codice Miscela',
      blendDescription: 'Descrizione della Miscela',
      blendDescriptionTT: 'Descrizione della Miscela',
      finalProductName: 'Nome Prodotto Finale',
      finalProductNameTT: 'Nome Prodotto Finale',
      finalProductCode: 'Codice Prodotto Finale',
      finalProductCodeTT: 'Codice Prodotto Finale',
      processType: 'Tipo di Processo',
      processTypeTT: 'Tipo di Processo',
      finalProductLotIdGen:
        'Generatore ID Lotto del Prodotto Finale della Miscela',
      finalProductLotIdGenTT:
        'Generatore ID Lotto del Prodotto Finale della Miscela',
      productDetails: 'Prodotti della Miscela (Ingredienti)',
      productDetailsTT: 'Prodotti della Miscela (Ingredienti)',
      selectType: 'Seleziona Tipo',
      startCount: 'Contatore Iniziale',
      resetCounterEach: 'Reimposta Contatore Ogni',
      enter: 'Inserisci',
      staticText: 'Testo Statico',
      incrementalNumber: 'Numero Incrementale',
      year: 'Anno',
      month: 'Mese',
      date: 'Data',
      none: 'Nessuno',
      space: 'Spazio',
      '0001': '0001',
      resetCounter: 'Reimposta contatore ogni',
      selectSeparator: 'Seleziona Separatore',
      previewLotId: 'Anteprima ID Lotto',
      blendProducts: 'Prodotti della Miscela',
      blendProductsTT: 'Prodotti della Miscela',
      product: 'Prodotto',
      productTT: 'Prodotto',
      selectProduct: 'Seleziona Prodotto',
      subProduct: 'Sottoprodotto',
      subProductTT: 'Sottoprodotto',
      selectSubProduct: 'Seleziona Sottoprodotto',
      originCountry: 'Paese di Origine',
      originCountryTT: 'Paese di Origine',
      selectCountry: 'Seleziona Paese',
      percentage: 'Percentuale',
      percentageTT: 'Percentuale',
      addAnotherProduct: 'Aggiungi un Altro Prodotto',
      confirmation: 'Conferma',
      createBlendMessage: 'Sei sicuro di voler aggiungere una nuova miscela?',
      updateBlendMessage: 'Sei sicuro di voler aggiornare questa miscela?',
      confirm: 'Conferma',
      pleaseFillRequiredFields: 'Compila i campi obbligatori',
      lightRoast: 'Tostatura Chiara',
      mediumRoast: 'Tostatura Media',
      mediumDarkRoast: 'Tostatura Media-Scura',
      darkRoast: 'Tostatura Scura',
      validation: {
        titleRequired: 'Il titolo è obbligatorio',
        codeRequired: 'Il codice miscela è obbligatorio',
        descriptionRequired: 'La descrizione è obbligatoria',
        finalProductNameRequired: 'Il nome del prodotto finale è obbligatorio',
        finalProductCodeRequired: 'Il codice del prodotto finale è obbligatorio',
        processTypeRequired: 'Il tipo di processo è obbligatorio',
        selectTypeRequired: 'Il tipo è obbligatorio',
        startCountRequired: 'Il contatore iniziale è obbligatorio',
        selectSeparatorRequired: 'Il separatore è obbligatorio',
        finalProductLotIdGenRequired:
          'La generazione dell’ID lotto del prodotto finale è obbligatoria',
        productRequired: 'Il prodotto è obbligatorio',
        subProductRequired: 'Il sottoprodotto è obbligatorio',
        originCountryRequired: 'Il paese di origine è obbligatorio',
        percentageRequired: 'La percentuale è obbligatoria',
        hundredPrecent: 'La percentuale totale deve essere esattamente il 100%',
        productSubproductDuplicatedMsg:
          'Il prodotto e il sottoprodotto sono duplicati',
      },
      mustSelectIncrementalNumber:
        'Deve essere selezionato almeno un numero incrementale',
      blendSettingsCreated:
        'Le impostazioni della miscela sono state create con successo.',
      blendSettingsNotCreated:
        'La creazione delle impostazioni della miscela non è riuscita. Riprova con dati corretti.',
      confirmDiaglog: {
        delete: {
          title: 'Elimina',
          message:
            'Sei sicuro di voler eliminare queste impostazioni della miscela?',
          confirmBtn: 'Conferma',
          cancelBtn: 'Annulla',
        },
      },
      itemDeletedSuccessfully:
        'Le impostazioni della miscela sono state eliminate con successo',
      updateBlend: 'Aggiorna Impostazioni Miscela',
      save: 'Salva',
      blendSettingsUpdated:
        'Le impostazioni della miscela sono state aggiornate con successo.',
      blendSettingsNotUpdated:
        'L’aggiornamento delle impostazioni della miscela non è riuscito. Riprova con dati corretti.',
      updateMessage: 'Sei sicuro di voler aggiornare questa miscela?',
      createMessage: 'Sei sicuro di voler aggiungere una nuova miscela?',
      finalProductCodeAlreadyExists: 'Il codice del prodotto finale esiste già',
      blendCodeAlreadyExists: 'Il codice della miscela esiste già.',
      valueMustBeNumber: 'Questo campo deve essere un numero',
      valueMustBeNonNegative: 'Questo campo deve essere maggiore di zero',
    },
    imports: {
      imports: 'Importazioni',
      blends: 'Miscele',
      createNewImport: 'Crea Nuova Importazione',
      importsBlends: 'Importa Miscele',
      createBlends: 'Crea Miscele',
      downloadTemplateInfo:
        'Scarica e utilizza i modelli seguenti per importare geofences in blocco.',
      selectTemplate: 'Seleziona Modello',
      downloadXlsTemplate: 'Scarica il Modello di Importazione XLS',
      downloadProductCodes: 'Scarica Codici Prodotti',
      selectFileToUpload: 'Seleziona un file per caricare i dati',
      orDragDrop: 'Oppure trascina e rilascia i file qui',
      removeFile: 'Rimuovi File',
      importantNote: 'Nota Importante',
      templateNote:
        'Utilizza i modelli forniti sopra per i caricamenti in blocco. Altri formati porteranno a errori.',
      importData:'Assicurati che questi dati non vengano conservati fino a quando tutti gli stati non saranno completati con successo.',
      fileUploadSuccess: 'File caricato con successo',
      invalidFileFormat: 'Formato file non valido. Carica un file valido',
      pleaseSelectSource: 'Seleziona almeno una fonte',
      blendTitle: 'Titolo Miscela',
      blendCode: 'Codice Miscela',
      finalProductCode: 'Codice Prodotto Finale',
      finalProductName: 'Nome Prodotto Finale',
      status: 'Stato',
      downloadCsvTemplate: 'Scarica il Modello di Importazione CSV',
      dropHere: 'oppure trascina e rilascia qui',
      Importing: 'Importazione in corso...',
      modalMessage:
        'Il file caricato è attualmente in fase di elaborazione. Ti informeremo una volta completato l’upload.',
      importXLSFormat: 'Importa Formato XLS',
      importCSVFormat: 'Importa Formato CSV',
      fileSelected: 'Il file è stato selezionato con successo.',
      success: 'Dati importati con successo.',
      importCompleted: 'Importazione Completata',
      invalidHeaders: "Intestazioni del file non valide",
      headerMismatchErro: "Il file caricato deve contenere le seguenti intestazioni",
      missingHeaders: "Intestazioni Mancanti",
      additionalHeaders: "Intestazioni Aggiuntive (non consentite)"
    },
    history: {
      history: 'Cronologia',
      fileName: 'Nome del File',
      importedOn: 'Importato il',
      status: 'Stato',
      action: 'Azione',
      blends: 'Miscele',
      download: 'Scarica',
      success: 'Successo',
      failed: 'Fallito'
    },
    createBlends: {
      eudrDueDiligence: 'Due Diligence EUDR',
      createBlends: 'Crea Miscele',
      discard: 'Scarta',
      reject: 'Rifiuta',
      saveAndContinueLater: 'Salva e Continua Più Tardi',
      generateReport: 'Genera Rapporto',
      generalData: 'Dati Generali',
      blend: 'Miscela',
      selectBlend: 'Seleziona Miscela',
      blendCode: 'Codice Miscela',
      blendDescription: 'Descrizione Miscela',
      finalProduct: 'Prodotto Finale',
      finalProductCode: 'Codice Prodotto Finale',
      netMass: 'Massa Netta',
      netMassTT: "Consente agli utenti di inserire il valore dell'imposta sulla massa netta associato a un prodotto, spedizione o transazione.",
      volume: 'Volume',
      volumeTT: "L'etichetta è visibilmente posizionata accanto a un campo o sezione in cui vengono presentati o inseriti dati relativi al volume, come nelle specifiche dei prodotti o nei moduli di spedizione.",
      blendLotId: 'ID Lotto Miscela',
      blendLotIdTT: "Mostra l'identificatore univoco del lotto secondo la configurazione delle impostazioni di Blend per tracciare il lotto della miscela.",
      finishedProductLotId: 'ID Lotto Prodotto Finito',
      finishedProductLotIdTT: "Inserisci l'identificatore univoco del lotto per tracciare il lotto finale del prodotto.",
      enterHere: 'Inserisci Qui',
      internalReferenceNumber: 'Numero di Riferimento Interno',
      internalReferenceNumberTT: "Codice di riferimento interno per scopi di tracciamento.",
      eudrReferenceNumber: 'Numero di Riferimento EUDR',
      eudrReferenceNumberTT: "Codice di riferimento per la conformità alla EUDR (Regolamento sulla Deforestazione dell'Unione Europea). Questo sarà compilato automaticamente se l'utente desidera caricarlo su EUDR dopo la creazione del rapporto.",
      companyId: 'ID Azienda',
      companyIdTT: "Identificatore per l'azienda associata a questa miscela.",
      activity: 'Attività',
      domestic: 'Domestico',
      import: 'Importazione',
      export: 'Esportazione',
      containerInformation: 'Informazioni sul Contenitore',
      containerInformationTT: "Questo è un identificatore univoco del contenitore. Inserisci l'ID del contenitore qui sotto.",
      addContainer: 'Aggiungi Contenitore',
      blendProduct: 'Prodotto Miscela',
      blendProductTT: "Aggiungi più Prodotti e Sotto-Prodotti dai Prodotti Esenti DDS/EUDR per creare una Miscela.",
      product: 'Prodotto',
      productTT: "Mostra agli utenti il prodotto scelto da un elenco di prodotti disponibili nelle Impostazioni di Miscela per l'elaborazione, l'analisi o la reportistica all'interno dell'applicazione, facilitando l'inserimento e la gestione accurata dei dati.",
      subProduct: 'Sottoprodotto',
      subProductTT: "Mostra agli utenti i sottoprodotti scelti tra quelli disponibili nelle Impostazioni di Miscela relativi a un prodotto principale selezionato, facilitando l'inserimento e la gestione dettagliata dei dati all'interno dell'applicazione.",
      ddsId: 'ID DDS',
      containerId: 'ID Contenitore',
      uniqueContainerId:"L'ID del contenitore deve essere unico",
      containerIdTT: "Identificatore univoco per il contenitore che trasporta questa miscela.",
      country: 'Paese',
      countryTT: "Scegli il paese associato all'origine o alla destinazione della miscela.",
      search: 'Cerca',
      select: 'Seleziona',
      addAnotherProduct: 'Aggiungi un Altro Prodotto',
      customization: 'Personalizzazione',
      recordsPerPage: 'Record per Pagina',
      restoreDefault: 'Ripristina Default',
      apply: 'Applica',
      applyFilter:"Applica filtro",
      clearFilter:"Cancella filtro",
      status: {
        compliant: 'Conforme',
        nonCompliant: 'Non Conforme',
        uploadToEudr:"CARICATO SUL PORTALE UE",
        eudrExempt: "ESENTE DA EUDR",
      },
      table: {
        eudrInternalRef: 'EUDR / No. di Riferimento Interno',
        containerId: 'ID Contenitore',
        product: 'Prodotto',
        farmsQuantity: 'Fattorie & Quantità',
        submissionDate: 'Data di Presentazione',
        dueDiligenceStatus: 'Stato Due Diligence',
        availabilityForBlends: 'Disponibilità per Miscele',
        pleaseSelectSource: 'Seleziona almeno una fonte',
      },
      productionPlaceTable: {
        productionPlaceAndFarmId: 'Luogo di Produzione e ID della Fattoria',
        product: 'Prodotto',
        producerName: 'Nome del Produttore',
        addressOfProduction: 'Indirizzo di Produzione',
        status: 'Stato Deforestazione EUDR',
        riskAssessment: 'Valutazione del Rischio',
      },
      
      addNewSupplier: 'Aggiungi Nuovo Fornitore',
      addNewBlend: 'Aggiungi Nuova Miscela',
      placeOfActivity: 'Luogo di Attività dell’Operatore',
      placeOfActivityTT: "Specifica il paese dell'operatore in cui si svolgono le attività e il paese in cui il prodotto entra nel mercato dell'UE. Questi dettagli sono essenziali per garantire la conformità ai requisiti EUDR.",
      countryOfActivity: 'Paese di Attività dell’Operatore',      
      countryOfActivityTT: "Seleziona il paese in cui si svolge questa attività.",
      countryOfEntry: 'Paese di Ingresso',
      countryOfEntryTT: "Seleziona il paese di ingresso per i prodotti importati.",
      pleaseSelectAtLeastOne: 'Seleziona almeno un rapporto di ciascun prodotto',
      blendCreatedSuccessfully: "Il blend è stato creato con successo.",
      blendCreateFailed: "Si è verificato un errore durante la creazione del blend.",
      blendUpdatedSuccessfully: "Il blend è stato aggiornato con successo.",
      blendUpdateFailed: "Si è verificato un errore durante l'aggiornamento del blend.",
      blendDeletedSuccessfully: "Il blend è stato eliminato con successo.",
      blendSavedSuccessfully: 'Il blend è stato salvato con successo.',
      blendUploadedToEUSuccessfully: "Il blend è stato caricato con successo nell'EU."
    },
    manageProducts: {
      addNewProduct: 'Aggiungi Nuovo Prodotto',
      editProduct: 'Modifica Prodotto',
      addNewSubProduct: 'Aggiungi Nuovo Sottoprodotto',
      editSubProduct: 'Modifica Sottoprodotto',
      productTitle: 'Titolo del Prodotto',
      subProductTitle: 'Titolo del Sottoprodotto',
      typeTitle: 'Digita Titolo',
      hsCode: 'Codice HS',
      typeHSCode: 'Digita Codice HS',
      eudrDocumentCode: 'Codice Documento EUDR',
      selectEudrDocumentCode: 'Seleziona Codice Documento EUDR',
      makeSelection: 'Effettua una selezione',
      uploadCategoryImage: 'Carica Immagine Categoria',
      addImage: 'Aggiungi Immagine',
      cancel: 'Annulla',
      save: 'Salva',
      back: 'Indietro',
      add: 'Aggiungi',
      confirm: 'Conferma',
      deleteMessage: 'Sei sicuro di voler rimuovere',
      invalidFileType: 'Tipo di File Non Valido',
      errorUploadingFile:
        'Si è verificato un errore imprevisto durante il caricamento del file. Riprova più tardi.',
      fileUploadFailed: 'Caricamento File Fallito',
      selectDocumentCode: 'Seleziona Codice Documento',
      view: 'Visualizza',
      edit: 'Modifica',
      remove: 'Rimuovi',
      search: 'Cerca',
      searchByProductName: 'Cerca per Nome Prodotto',
      eudrDueDiligence: 'Due Diligence EUDR',
      products: 'Prodotti',
      subProducts: 'Sottoprodotti',
      fieldRequired: 'Questo campo è obbligatorio',
      fileRequired: 'File Obbligatorio',
      fileRequiredMessage:
        'Carica o seleziona un file prima di salvare il prodotto.',
      addNewDocumentCode: 'Aggiungi Nuovo Codice Documento',
      enterHere: 'Inserisci qui',
      documentCode: 'Codice Documento',
      title: 'Titolo',
      description: 'Descrizione',
      updateProduct: 'Aggiorna Prodotto',
      updateSubProduct: 'Aggiorna Sottoprodotto',
      deleteSubProduct: 'Elimina Sottoprodotto',
      deleteProduct: 'Elimina Prodotto',
      productAddedMessage: 'Prodotto aggiunto con successo.',
      subProductAddedMessage: 'Sottoprodotto aggiunto con successo.',
      productUpdateMessage: 'Prodotto aggiornato con successo.',
      subProductUpdateMessage: 'Sottoprodotto aggiornato con successo.',
      subProductDeleteMessage: 'Sottoprodotto eliminato con successo.',
      productDeleteMessage: 'Prodotto eliminato con successo.',
      pleaseTryAgain: 'Qualcosa è andato storto. Riprova più tardi.',
      documentCodeDuplicate: 'Il codice documento esiste già',
      unsupportedFileFormat: 'Tipo di file non supportato. Si prega di caricare un file immagine valido.',
      tableHeaders: {
        productName: 'Nome Prodotto',
        hsCode: 'Codice HS',
        eudrDocumentCode: 'Codice Documento EUDR',
        subProduct: 'Sottoprodotti',
        dateAdded: 'Data di Aggiunta',
        action: 'Azioni',
      },
      documentCodeSaved: 'Codice Documento salvato con successo.',
    },
    finalReport: {
      title: 'Rapporto Finale Miscele',
      reportStatus: 'Stato del Rapporto',
      blendTitle: 'Titolo Miscela',
      blendCode: 'Codice Miscela',
      finalProduct: 'Prodotto Finale',
      finalProductCode: 'Codice Prodotto Finale',
      blendDescription: 'Descrizione Miscela',
      processType: 'Tipo di Processo',
      netMass: 'Massa Netta',
      volume: 'Volume',
      blendLotId: 'ID Lotto Miscela',
      finalProductLotId: 'ID Lotto Prodotto Finale',
      internalReferenceNumber: 'Numero di Riferimento Interno',
      eudrReferenceNumber: 'Numero di Riferimento EUDR',
      activity: 'Attività',
      countryOfActivity: 'Paese dell’Attività',
      countryOfEntry: 'Paese di Entrata',
      dueDiligenceReportStatus: 'Stato del Rapporto di Due Diligence',
      containerId: 'ID Contenitore',
      operatorData: 'Dati Operatore',
      name: 'Nome',
      country: 'Paese',
      isoCode: 'Codice ISO',
      eoriNumber: 'Numero EORI',
      reportSummary: {
        title: 'Riepilogo del Rapporto',
        totalDdsReports: 'Numero Totale di Rapporti DDS',
        totalGeofencePolygons: 'Numero Totale di Poligoni Geofence',
        totalGeofencePoints: 'Numero Totale di Punti Geofence',
        totalDeforestationAssessments:
          'Numero Totale di Valutazioni Deforestazione',
        totalRiskAssessments: 'Numero Totale di Valutazioni del Rischio',
        totalFarms: 'Numero Totale di Fattorie',
        totalHighDeforestationFarms: 'Numero di Fattorie ad Alta Deforestazione',
        totalLowZeroRiskFarms: 'Numero di Fattorie a Rischio Basso o Zero',
        totalArea: 'Area Totale (ha)',
        averageGeofenceArea: 'Area Media Geofence (ha)',
        totalHighRiskFarmArea: 'Area Totale delle Fattorie ad Alto Rischio',
        totalLowZeroRiskFarmArea:
          'Area Totale delle Fattorie a Rischio Basso o Zero',
        productionPlaces: 'Luoghi di Produzione',
        productionPlacesTooltip: 'Dettagli sui luoghi di produzione',
        declarationStatement: 'Dichiarazione dell’Operatore',
        declarationStatementTooltip: 'Dichiarazione ufficiale dell’operatore',
        declarationText1:
          '[Nome] {name}, dichiaro che tutti i dati inviati con questa spedizione sono accurati al meglio delle mie conoscenze e convinzioni.',
        declarationText2:
          'Io, [Nome] {name}, affermo di aver visitato le fattorie associate a questa spedizione e confermo la loro conformità alle leggi e ai regolamenti locali sulla deforestazione.',
      },
      blendProducts: {
        title: 'Prodotti della Miscela',
        product: 'Prodotto',
        subProduct: 'Sottoprodotto',
        country: 'Paese',
        reference: 'EUDR / No. di Riferimento Interno',
        containerId: 'ID Contenitore',
        farmsQuantity: 'Fattorie & Quantità',
        submissionDate: 'Data di Invio',
        status: 'Stato',
      },
      activityLog: {
        title: 'Registro delle Attività',
        user: 'Utente',
        userRole: 'Ruolo Utente',
        ipAddress: 'Indirizzo IP',
        dateTime: 'Data & Ora',
        segment: 'Segmento',
        activityDescription: 'Descrizione dell’Attività',
      },
      declaration: {
        title: 'Dichiarazione dell’Operatore',
        name: 'Nome',
        address: 'Indirizzo',
        dateTime: 'Data & Ora',
      },
      buttons: {
        discard: 'Scarta',
        reject: 'Rifiuta',
        edit: 'Modifica',
        finalize: 'Finalizza',
        download: 'Scarica',
        uploadToEuPortal: 'Carica sul Portale EU',
        submit: 'Invia',
      },
    },
  }
};